import { SVGProps, useEffect, useState } from "react";
import { EngineViewModel } from "../../api/modelInfoApi";
import ModelInfoEngineEditModal from "../modals/ModelInfoEngineEditModal";
import { Button } from "react-bootstrap";
import { HybrideTypeModel } from "../../api/hybridTypeApi";
import { Vehicle } from "../../vehicleFiles/ModelInfos";

interface ModelInfoEngineEditButtonProps {
  vehicle: Vehicle;
  hybridTypes: HybrideTypeModel[];
  disabled: boolean;
  engineCell: any;
  engineKey: string;
  onContextMenu: (cell: any, key: string) => void;
  onShow: (show: boolean) => void;
  onChange: (value: EngineViewModel, isEngineModified: boolean) => void;
  updateIsEngineModified: (
    initialEngine: EngineViewModel,
    currentEngine: EngineViewModel,
  ) => void;
}

function ModelInfoEngineEditButton({
  vehicle,
  hybridTypes,
  disabled,
  engineCell,
  engineKey,
  onContextMenu,
  onShow,
  onChange,
  updateIsEngineModified,
}: ModelInfoEngineEditButtonProps) {
  const [show, setShow] = useState(false);
  const [isModified, setIsModified] = useState(false);

  const handleShow = () => {
    setShow(true);
    onShow(true);
  };

  const handleClosingModal = (newEngine: EngineViewModel) => {
    setShow(false);
    updateIsEngineModified(vehicle.initialValue.engine, newEngine);
    onChange(newEngine, vehicle.isEngineModified);
    onShow(false);
  };

  useEffect(() => {
    updateIsEngineModified(
      vehicle.initialValue.engine,
      vehicle.currentValue.engine,
    );
    setIsModified(vehicle.isEngineModified);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [vehicle.currentValue.engine, vehicle.initialValue.engine]);

  return (
    <>
      <Button
        onClick={handleShow}
        style={{ width: "fit-content", padding: "3px 6px", minWidth: "80%" }}
        variant={isModified ? "warning" : "primary"}
        size="sm"
      >
        <LineMdEngine width={23} height={23} />
      </Button>
      {show ? (
        <div onContextMenu={(e) => e.stopPropagation()}>
          <ModelInfoEngineEditModal
            vehicle={vehicle}
            hybridTypes={hybridTypes}
            disabled={disabled}
            engineCell={engineCell}
            engineKey={engineKey}
            onContextMenu={(cell, key) => {
              onContextMenu(cell, key);
            }}
            onCancel={handleClosingModal}
          />
        </div>
      ) : null}
    </>
  );
}

export default ModelInfoEngineEditButton;

function LineMdEngine(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <g
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M11 9h6v10h-6.5l-2 -2h-2.5v-6.5l1.5 -1.5Z"></path>
        <path fill="currentColor" d="M17 13h4v-3h1v8h-1v-3h-4z"></path>
        <path d="M6 14h-4M2 11v6"></path>
        <path d="M11 9v-4M8 5h6"></path>
      </g>
    </svg>
  );
}
